module.exports = __webpack_public_path__ + "static/img/Dharma Favitri Hariyanto-full.03f86ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Dharma Favitri Hariyanto-full.png
// module id = J1sL
// module chunks = 1